"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The ListAddRemoveEntitiesParams model module.
 * @module model/ListAddRemoveEntitiesParams
 * @version 1.1.3-alpha.1
 */
class ListAddRemoveEntitiesParams {
  /**
   * Constructs a new <code>ListAddRemoveEntitiesParams</code>.
   * @alias module:model/ListAddRemoveEntitiesParams
   * @param ids {Array.<String>} 
   */
  constructor(ids) {
    ListAddRemoveEntitiesParams.initialize(this, ids);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, ids) {
    obj['ids'] = ids;
  }

  /**
   * Constructs a <code>ListAddRemoveEntitiesParams</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ListAddRemoveEntitiesParams} obj Optional instance to populate.
   * @return {module:model/ListAddRemoveEntitiesParams} The populated <code>ListAddRemoveEntitiesParams</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ListAddRemoveEntitiesParams();
      if (data.hasOwnProperty('ids')) {
        obj['ids'] = _ApiClient.default.convertToType(data['ids'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>ListAddRemoveEntitiesParams</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ListAddRemoveEntitiesParams</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of ListAddRemoveEntitiesParams.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is an array
    if (!Array.isArray(data['ids'])) {
      throw new Error("Expected the field `ids` to be an array in the JSON data but got " + data['ids']);
    }
    return true;
  }
}
ListAddRemoveEntitiesParams.RequiredProperties = ["ids"];

/**
 * @member {Array.<String>} ids
 */
ListAddRemoveEntitiesParams.prototype['ids'] = undefined;
var _default = exports.default = ListAddRemoveEntitiesParams;